/**
 * Created by anatoly on 03.07.2025
 */

const CupHintView = function () {
    this.hintFinger = undefined;

    cleverapps.availableMove.on("hide", this.hide.bind(this));
    cleverapps.availableMove.on("cup", this.show.bind(this));
};

CupHintView.prototype.show = function (move) {
    this.hide();

    this.hintFinger = FingerView.hintTap(move.target, {
        delay: move.delay / 1000,
        repeatDelay: move.interval / 1000
    });
};

CupHintView.prototype.hide = function () {
    FingerView.remove(this.hintFinger);
    this.hintFinger = undefined;
};